import { ValidateCodeResponse } from './types';

export const CODE_VALIDATE_ERRORS = {
  CODE_NOT_FOUND: 'CODE_NOT_FOUND',
  INVALID_STATE: 'INVALID_STATE',
  ORDER_ON_ANOTHER_DEVICE: 'ORDER_ON_ANOTHER_DEVICE',
} as const;

export class HelmsdeepValidateCodeErrorResponse extends Error {
  error: {
    title: string;
  } = { title: '' };
  detail: Partial<{
    assignedDeviceName: string;
    codeType: string;
    currentState: string;
  }> = {};
  constructor(error: NonNullable<ValidateCodeResponse['error']>) {
    super(error.type);
    this.name = 'HelmsdeepValidateCodeErrorResponse';
    this.error.title = error.type;
    this.detail = error.detail;
  }
}
